import { PageHeader } from '@/components/layout/PageHeader';
import { SocialInboxWorkspace } from '../components/SocialInboxWorkspace';

export function SocialInboxPage() {
  return (
    <div>
      <PageHeader
        title="Unified Inbox"
        description="Facebook, Instagram, WhatsApp, Telegram, and all messaging-capable channels in one queue"
        breadcrumbs={[{ label: 'Social', to: '/social' }, { label: 'Inbox' }]}
      />
      <SocialInboxWorkspace title="All channels" />
    </div>
  );
}
